export function categoryQuery(filters = {}) {
  const { category, categories, ...rest } = filters;
  const selected = Array.isArray(categories) ? categories : Array.isArray(category) ? category : null;
  if (selected) return selected.length ? { ...rest, categories: JSON.stringify(selected) } : rest;
  if (categories) return { ...rest, categories };
  return category && category !== 'all' ? { ...rest, category } : rest;
}

export function appendCategoryFilters(params, filters) {
  const query = categoryQuery({ category: filters.category, categories: filters.categories });
  Object.entries(query).forEach(([key, value]) => params.append(key, value));
}
